import type { LucideIcon } from "lucide-react";
import {
  Ban,
  Bolt,
  CircleStop,
  Flame,
  Hourglass,
  Lock,
  Play,
  Rocket,
  Shield,
  Target,
  Timer,
  Zap,
} from "lucide-react";

import { DEFAULT_FAB_ICON } from "./quickStartSession";

export type QuickStartFabIconName =
  | "Zap"
  | "Play"
  | "Shield"
  | "Timer"
  | "Rocket"
  | "Flame"
  | "Lock"
  | "Ban"
  | "Target"
  | "Bolt"
  | "Hourglass"
  | "CircleStop";

export const QUICK_START_FAB_ICONS: ReadonlyArray<{
  name: QuickStartFabIconName;
  Icon: LucideIcon;
}> = [
  { name: "Zap", Icon: Zap },
  { name: "Play", Icon: Play },
  { name: "Shield", Icon: Shield },
  { name: "Timer", Icon: Timer },
  { name: "Rocket", Icon: Rocket },
  { name: "Flame", Icon: Flame },
  { name: "Lock", Icon: Lock },
  { name: "Ban", Icon: Ban },
  { name: "Target", Icon: Target },
  { name: "Bolt", Icon: Bolt },
  { name: "Hourglass", Icon: Hourglass },
  { name: "CircleStop", Icon: CircleStop },
];

const ICON_BY_NAME = new Map(QUICK_START_FAB_ICONS.map((entry) => [entry.name, entry.Icon]));

export function resolveQuickStartFabIcon(name: string | undefined): LucideIcon {
  if (!name) return ICON_BY_NAME.get(DEFAULT_FAB_ICON as QuickStartFabIconName) ?? Zap;
  return ICON_BY_NAME.get(name as QuickStartFabIconName) ?? Zap;
}

export function isQuickStartFabIconName(name: string): name is QuickStartFabIconName {
  return ICON_BY_NAME.has(name as QuickStartFabIconName);
}
